import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { Input, RadioGroup, RadioOption, Dropdown, DropdownOption, Button, Icon } from '@abb/abb-common-ux-react';
import SubmitHeader from "../shared/SubmitHeader";
import history from "../../utilities/History";
import "./scanner.sass";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import IFormComponent from "../../models/shared/FormComponent";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { Translation } from "react-i18next";
import settingsActions from '../../flux/actions/SettingsAction';
import sampleSettingStore from '../../flux/stores/settings/SampleSettingStore';
import { IMapping, IScannerFormData, ScannerFormData } from '../../models/scanner/ScannerFormData';
import scannerActions from '../../flux/actions/ScannerAction';
import { v4 as uuidv4 } from 'uuid';
import scannerFormStore from '../../flux/stores/scanner/FormStore';
import _ from "lodash";
import { LABEL_ADD } from '../../utilities/Constants';

type PropsType = RouteComponentProps & {};

interface IState {
  scannerFormData: IScannerFormData;
  oldData: IScannerFormData;
  formLoading: boolean;
  nameError: boolean;
  endDateError: boolean;
  selectedSampleFields: any[];
  sampleFields: any[];
  selectedType: string;
}

class Form extends React.Component<PropsType, IState> implements IFormComponent {
  _mount: boolean;
  _isReload: boolean;
  _id: string;
  _messages: string[];
  private _sampleFields: any[];

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as IScannerFormData;

    this.state = {
      scannerFormData: pushStateData,
      formLoading: false,
      oldData: { ...pushStateData },
      nameError: false,
      endDateError: false,
      selectedSampleFields: [],
      sampleFields: [],
      selectedType: CONSTANTS.DELIMITER,
    };
    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidUpdate() {
    if (JSON.stringify(this.state.oldData) !== JSON.stringify(this.state.scannerFormData)) {
      navigationHeaderActions.updateHeader({
        name: CONSTANTS.MODULE_SCANNER,
        action: this.state.scannerFormData.isEditMode ? CONSTANTS.EDIT : CONSTANTS.CREATE,
        icon: this.state.scannerFormData.isEditMode ? ICONCONSTANTS.ABB_EDIT : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.SCANNER_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: true
      }).then();
    }
  }

  componentDidMount() {
    this._mount = true;

    if (this.state.scannerFormData?.isEditMode) {
      const type = this.state.scannerFormData.isDelimited ? CONSTANTS.DELIMITER : CONSTANTS.SUBSTRING;
      this.setState({
        selectedType: type
      })
    }

    if (this.state.scannerFormData?.isEditMode) {
      submitHeaderActions.update({
        moduleName: CONSTANTS.MODULE_SCANNER,
        isSubmitDisabled: false
      }).then();
    }
    navigationHeaderActions.updateHeader({
      name: CONSTANTS.MODULE_SCANNER,
      action: this.state.scannerFormData.isEditMode ? CONSTANTS.EDIT : CONSTANTS.CREATE,
      icon: this.state.scannerFormData.isEditMode ? ICONCONSTANTS.ABB_EDIT : ICONCONSTANTS.ABB_PLUS,
      goBackUrl: CONSTANTS.SCANNER_INDEX_URL,
      isGoBackWithData: false,
      goBackData: {},
      isDataChanged: false
    }).then();

    scannerFormStore.on(CONSTANTS.CHANGE_EVENT, state => {
      if (this._mount) {
        this._isReload = false;
        this._id = state.Id;
        this._messages = state.message;
      }
    });

    sampleSettingStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._sampleFields = state.data
      }
    });

    this.getSampleSettings();
  }


  private getSampleSettings = () => {
    settingsActions.getSampleFieldsShow().then(() => {
      const sampleFields: any[] = [];
      this._sampleFields.map((x) => sampleFields.push({ id: x.id, key: x.key, name: x.name, show: x.show, isDisable: false }));
      const sortedSampleFields = _.orderBy(sampleFields, ['name'], ['asc']);
      this.setState({
        sampleFields: sortedSampleFields
      }, () => {
        if (this.state.scannerFormData?.isEditMode) {
          if (this.state.selectedType === CONSTANTS.DELIMITER) {
            const selectedSampleFields: any[] = [];
            const arr = this.state.scannerFormData.scannerContent.split(this.state.scannerFormData.delimiter);
            const mappings: any[] = [];
            const sampleFields = this.state.sampleFields;
            this.state.scannerFormData.mappings.map((d, i) => {
              const sampleField = this.state.sampleFields.find(x => x.name === d.sampleFieldKey);
              const sampleFieldIndex = this.state.sampleFields.findIndex(x => x.name === d.sampleFieldKey);
              if (sampleField !== undefined) {
                sampleField.isDisable = true;
                sampleFields[sampleFieldIndex] = sampleField;
                selectedSampleFields.push({ value: sampleField.id, label: sampleField.key });
                mappings.push({ ...d, sampleKeys: [{ value: sampleField.id, label: sampleField.key }], dataValue: arr[i] });
              }
            })

            this.setState({
              selectedSampleFields, sampleFields,
              scannerFormData: {
                ...this.state.scannerFormData,
                mappings
              }
            })
          } else {
            const selectedSampleFields: any[] = [];
            const mappings: any[] = [];
            const sampleFields = this.state.sampleFields;
            this.state.scannerFormData.mappings.map((d, i) => {
              const sampleField = this.state.sampleFields.find(x => x.name === d.sampleFieldKey);
              const sampleFieldIndex = this.state.sampleFields.findIndex(x => x.name === d.sampleFieldKey);

              const dataValue = this.state.scannerFormData.scannerContent.substring(d.startIndex - 1, d.endIndex)
              if (sampleField !== undefined) {
                sampleField.isDisable = true;
                sampleFields[sampleFieldIndex] = sampleField;
                selectedSampleFields.push({ value: sampleField.id, label: sampleField.key });
                mappings.push({ ...d, sampleKeys: [{ value: sampleField.id, label: sampleField.key }], dataValue });
              }

            })
            this.setState({
              selectedSampleFields, sampleFields,
              scannerFormData: {
                ...this.state.scannerFormData,
                mappings
              }
            })

          }
        }
      })
    }).catch((e) => {
      triggerNotifications.error(e);
    })
  }

  private setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "")
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      this.setState({
        nameError: false,
        scannerFormData: {
          ...this.state.scannerFormData,
          name: val
        }
      }, this.validate)
    } else {
      this.setState({
        nameError: true,
        scannerFormData: {
          ...this.state.scannerFormData,
          name: val
        }
      }, this.validate)
    }

  }

  private setDelimiter = (value: string) => {
    this.setState({
      scannerFormData: {
        ...this.state.scannerFormData,
        delimiter: value
      }
    }, () => this.getPreviewContent())
  }

  private setPreview = (value: any) => {
    const scannerContent = value;
    this.setState({
      scannerFormData: {
        ...this.state.scannerFormData,
        scannerContent
      }
    }, () => this.getPreviewContent())
  }

  private getPreviewContent = () => {
    this.state.sampleFields.forEach(x => {
      x.isDisable = false;
    });
    if (this.state.selectedType === CONSTANTS.DELIMITER) {
      const arr = this.state.scannerFormData.scannerContent.split(this.state.scannerFormData.delimiter);
      const mappings: any[] = [];
      arr.map((d, i) => {
        mappings.push({ sampleFieldKey: "", dataValue: d, isDisable: false });
      })
      this.setState({
        scannerFormData: {
          ...this.state.scannerFormData,
          mappings
        }
      }, this.validate)
    } else {
      let mappings = this.state.scannerFormData.mappings;
      mappings = [];
      this.setState({
        scannerFormData: {
          ...this.state.scannerFormData,
          mappings
        }
      }, this.validate)
    }
  }

  private onSampleFieldsChange(value: any, i: number): void {
    const mappings = this.state.scannerFormData.mappings;

    const sampleFields = this.state.sampleFields;
    const sampleField = this.state.sampleFields.find(x => x.id === value[0].value);
    const sampleFieldIndex = this.state.sampleFields.findIndex(x => x.id === value[0].value);

    const mapping = mappings[i];
    mapping.sampleKeys = value;
    mapping.sampleFieldKey = value[0].label;

    sampleField.isDisable = true;
    sampleFields[sampleFieldIndex] = sampleField;

    this.setState({
      sampleFields,
      selectedSampleFields: value,
      scannerFormData: {
        ...this.state.scannerFormData,
        mappings
      }
    }, () => {
      this.state.sampleFields.map((d) => {
        const mapData = this.state.scannerFormData.mappings.find(x => x.sampleFieldKey === d.name);
        if (mapData === undefined) {
          d.isDisable = false
        }
      });
      this.setState({
        sampleFields
      }, () => {
        this.validate();
        if(this.state.scannerFormData.mappings[0].endIndex !== undefined) {
          this.validateEndNumber();
        }
      })
    })
  }

  validate(): void {
    if (this.state.scannerFormData.name
      && this.state.scannerFormData.name.trim()
      && !this.state.scannerFormData.mappings.some(x => x.sampleFieldKey === "")) {
      submitHeaderActions.update({
        moduleName: CONSTANTS.MODULE_SCANNER,
        isSubmitDisabled: false
      }).then();
    } else {
      submitHeaderActions.update({
        moduleName: CONSTANTS.MODULE_SCANNER,
        isSubmitDisabled: true
      }).then();
    }
  }

  public onSaveClick = () => {
    const tempName = this.state.scannerFormData.name.replace(/ +(?= )/g, '').trim();
    this.setState((prevState) => ({
      formLoading: true,
      scannerFormData: {
        ...prevState.scannerFormData,
        name: tempName
      }
    }), () => {
      const isDelimited = this.state.selectedType === CONSTANTS.DELIMITER ? true : false;
      const data = new ScannerFormData(
        this.state.scannerFormData.isEditMode,
        this.state.scannerFormData.requestId,
        this.state.scannerFormData.id,
        this.state.scannerFormData.name,
        isDelimited,
        this.state.scannerFormData.delimiter,
        this.state.scannerFormData.mappings,
        this.state.scannerFormData.isEnabled,
        this.state.scannerFormData.scannerContent,
      );
      // put api here
      scannerActions.put(data, uuidv4()).then(() => {
        this.setState({
          formLoading: false
        }, () => {
          triggerNotifications.success(this._messages);
          submitHeaderActions.update({
            moduleName: CONSTANTS.MODULE_SCANNER,
            isSubmitDisabled: true
          }).then();
          setTimeout(() => {
            history.push("/utility/scanner", { isReloadFirst: this._isReload, id: this._id });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        });
      }).catch((error: any) => {
        this.setState({
          formLoading: false
        }, () => triggerNotifications.errors(error.message, error.data).then());
      });
    });
  }

  public onCreateClick = () => {
    const tempName = this.state.scannerFormData.name.replace(/ +(?= )/g, '').trim();
    this.setState((prevState) => ({
      formLoading: true,
      scannerFormData: {
        ...prevState.scannerFormData,
        name: tempName
      }
    }), () => {
      const isDelimited = this.state.selectedType === CONSTANTS.DELIMITER ? true : false;
      const formData = this.state.scannerFormData;
      const data = new ScannerFormData(
        formData.isEditMode,
        formData.requestId,
        formData.id,
        formData.name,
        isDelimited,
        formData.delimiter,
        formData.mappings,
        formData.isEnabled,
        formData.scannerContent
      );

      scannerActions.post(data, uuidv4()).then(() => {
        this.setState({
          formLoading: false
        }, () => {
          triggerNotifications.success(this._messages);
          submitHeaderActions.update({
            moduleName: CONSTANTS.MODULE_SCANNER,
            isSubmitDisabled: true
          }).then();
          setTimeout(() => {
            history.push("/utility/scanner", { isReloadFirst: this._isReload, id: this._id });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        });
      }).catch((error) => {
        this.setState({
          formLoading: false
        }, () => triggerNotifications.errors(error.message, error.data).then());
      });
    })
  }

  private setEndIndex(v: string, i: number) {
    const mappings = this.state.scannerFormData.mappings;
    const mapping = mappings[i];
    mapping.endIndex = Number(v);
    if (mapping.endIndex == 0) {
      this.state.scannerFormData.scannerContent.charAt(mapping.startIndex - 1);
    } else {
      mapping.dataValue = this.state.scannerFormData.scannerContent.substring(mapping.startIndex - 1, mapping.endIndex);
    }
    this.setState({
      scannerFormData: {
        ...this.state.scannerFormData,
        mappings
      }
    }, () => {
      this.validateEndNumber();
    })
  }
  private setStartIndex(v: string, i: number) {
    const mappings = this.state.scannerFormData.mappings;
    const mapping = mappings[i];
    mapping.startIndex = Number(v);
    mapping.dataValue = mapping.endIndex ? this.state.scannerFormData.scannerContent.substring(mapping.startIndex - 1, mapping.endIndex) : this.state.scannerFormData.scannerContent.charAt(mapping.startIndex - 1);
    this.setState({
      scannerFormData: {
        ...this.state.scannerFormData,
        mappings
      }
    }, () => {
      this.validateEndNumber();
    })
  }

  private validateEndNumber() {
    const endError = this.state.scannerFormData.mappings.every(d => d.endIndex >= d.startIndex);
    if (!this.state.scannerFormData.mappings.some(x => x.sampleFieldKey === "") && endError) {
      submitHeaderActions.update({
        moduleName: CONSTANTS.MODULE_SCANNER,
        isSubmitDisabled: false
      }).then();
    } else {
      submitHeaderActions.update({
        moduleName: CONSTANTS.MODULE_SCANNER,
        isSubmitDisabled: true
      }).then();
    }
  }

  private onChangeType(v: string): void {
    this.setState({
      selectedType: v
    }, () => this.getPreviewContent())
  }

  private addRow = () => {
    const mappings = this.state.scannerFormData.mappings;
    mappings.push({ sampleFieldKey: "", endIndex: 0, startIndex: 0, dataValue: "" });
    this.setState({
      scannerFormData: {
        ...this.state.scannerFormData,
        mappings
      }
    }, this.validate)
  }

  private deleteRow = (d: IMapping, i: number) => {
    var mappings = [...this.state.scannerFormData.mappings];
    mappings.splice(i, 1);
    const mappdata = this.state.scannerFormData.mappings.find(x => x.sampleFieldKey === d.sampleFieldKey)
    this.state.sampleFields.map((s) => {
      if (mappdata.sampleFieldKey === s.name) {
        s.isDisable = false
      }
    });
    this.setState({
      scannerFormData: {
        ...this.state.scannerFormData,
        mappings
      }
    }, this.validate)
  }

  onCancelClick = () => {
    history.push(CONSTANTS.SCANNER_INDEX_URL, { isReloadFirst: this._isReload, id: this._id });
}

  public render() {
    return (
      <Translation>
        {
          t =>
            <div className="page-scroll">
              <div className="layout-container">
                <SubmitHeader
                  name={t(CONSTANTS.MODULE_SCANNER)}
                  isEdit={this.state.scannerFormData.isEditMode}
                  onSaveClick={this.onSaveClick}
                  onCreateClick={this.onCreateClick}
                  onCancelClick={this.onCancelClick}
                  isLoading={this.state.formLoading}
                />
                <div className="mt-3">
                  <div className="col-6 no-padding float-left">
                    <div className="box box-min-height">
                      <div className="box-circle">
                        <p className="box-circle-text"> 1 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">{t(CONSTANTS.MODULE_SCANNER) + " " + t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}</p>
                      </div>
                      <hr className="hr-line" />
                      <div className="row mt-1">
                        <div className="col-sm col-md">
                          <Input
                            dataType="text"
                            label={t(CONSTANTS.LABEL_PROFILE_NAME)}
                            required={true}
                            className={this.state.nameError ? "error-code mt-2 w-75" : "mt-2 w-75"}
                            value={this.state.scannerFormData.name}
                            onValueChange={this.setName}
                            maxLength={20}
                            placeholder={t(CONSTANTS.LABEL_PROFILE_NAME)}
                            showValidationBarWhenInvalid={this.state.nameError ? true : false}
                            description={this.state.nameError ? this.state.scannerFormData.name.length ? "" : t(CONSTANTS.FIELD_EMPTY_ERROR) : "" }
                          />
                        </div>
                      </div>

                      <div className="mt-1 form-group" style={{ "marginLeft": "16px" , "marginRight": "40px" }}>
                        <label className="text-preview">{t(CONSTANTS.LABEL_PREVIEW)}</label>
                        <div>
                          <Input
                            dataType="text"
                            className="mt-2 w-75"
                            required={true}
                            placeholder={t(CONSTANTS.LABEL_PREVIEW)}
                            value={this.state.scannerFormData.scannerContent}
                            onValueChange={this.setPreview}
                          /></div>
                      </div>

                      <div className="row mt-1">
                        <div className="row mt-1 ml-1">
                          <label className="text-preview">{t(CONSTANTS.LABEL_SAVE_FORMAT)}</label>
                          <RadioGroup
                            sizeClass={"small"}
                            value={this.state.selectedType}
                            orientation="horizontal"
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(v) => this.onChangeType(v)}>
                            <RadioOption text={t(CONSTANTS.DELIMITER)} value={CONSTANTS.DELIMITER} />
                            <RadioOption text={t(CONSTANTS.SUBSTRING)} value={CONSTANTS.SUBSTRING} />
                          </RadioGroup>
                        </div>
                      </div>

                      {this.state.selectedType === CONSTANTS.DELIMITER && <div className="row mt-1">
                        <div className="col-sm col-md">
                          <Input
                            dataType="text"
                            label={t(CONSTANTS.DELIMITER)}
                            className="mt-2 w-75"
                            value={this.state.scannerFormData.delimiter}
                            placeholder={t(CONSTANTS.DELIMITER)}
                            onValueChange={this.setDelimiter}
                            maxLength={1}
                          />
                        </div>
                      </div>}
                    </div>
                  </div>
                  <div className="col-6 no-padding float-left">
                    <div className="box ml-3 box-min-height">
                      <div className="box-circle">
                        <p className="box-circle-text">2</p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">{t(CONSTANTS.LABEL_MAPPINGS)}</p>
                      </div>
                      <hr className="hr-line" />
                      <div className="mt-3">
                        <div className="row ml-1"
                        >
                          {this.state.selectedType === CONSTANTS.SUBSTRING &&
                            <div>
                              <p><b>{t(CONSTANTS.NOTE)}</b>: {t(CONSTANTS.SUBSTRING_MESSAGE)}</p>
                              <span className="" >{ t("End Number should be greater than Start Number") } </span>
                            </div>
                          }
                          <table className="abb-scanner-table">
                            <thead>
                              <tr>
                                <th>{t(CONSTANTS.LABEL_KEY_FIELD)}</th>
                                {this.state.selectedType === CONSTANTS.SUBSTRING && <React.Fragment>
                                  <th className="index-row">{t(CONSTANTS.LABEL_START_NUMBER)}</th>
                                  <th className="index-row">{t(CONSTANTS.LABEL_END_NUMBER)}</th>
                                </React.Fragment>
                                }
                                <th>{t(CONSTANTS.LABEL_VALUE)}</th>
                                {this.state.selectedType === CONSTANTS.SUBSTRING &&
                                  <th className="index-row" />
                                }
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.scannerFormData.mappings.length === 0 &&
                                <tr>
                                  <td colSpan={2}>{t(CONSTANTS.NO_PREVIEW_CONTENT)}</td>
                                </tr>}
                              {this.state.scannerFormData.mappings.map((d, i) => {
                                return <React.Fragment key={i}>
                                  <tr>
                                    <td className="normal-row">
                                      <Dropdown
                                        className="w-75"
                                        searchable={true}
                                        placeholder={t(CONSTANTS.LABEL_PICK_FIELDS)}
                                        value={d.sampleKeys}
                                        // tslint:disable-next-line: jsx-no-lambda
                                        onChange={(value) => this.onSampleFieldsChange(value, i)}>
                                        {this.state.sampleFields.map(o => (
                                          <DropdownOption key={o.id} label={o.name} value={o.id}
                                            disabled={o?.isDisable}
                                          />
                                        ))}
                                      </Dropdown></td>
                                    {this.state.selectedType === CONSTANTS.SUBSTRING && <React.Fragment>
                                      <td className="normal-row index-row"><Input
                                        dataType="number"
                                        className="index-input"
                                        maxLength={3}
                                        value={String(d.startIndex)}
                                        // tslint:disable-next-line: jsx-no-lambda
                                        onValueChange={(v) => this.setStartIndex(v, i)}
                                      /></td>
                                      <td className="normal-row index-row"><Input
                                        dataType="number"
                                        className={(d.endIndex >= d.startIndex) ? "index-input" : "end-index-error index-input"}
                                        maxLength={3}
                                        value={String(d.endIndex)}

                                        // tslint:disable-next-line: jsx-no-lambda
                                        onValueChange={(v) => this.setEndIndex(v, i)}
                                      /></td></React.Fragment>}
                                    <td className="normal-row">{d?.dataValue}</td>
                                    <td className="normal-row">
                                      <Icon
                                        onClick={() => this.deleteRow(d, i)}
                                        name="abb/minus-in-circle"
                                        sizeClass="medium"
                                        color="blue"
                                      />
                                    </td>
                                  </tr>

                                </React.Fragment>
                              })}
                              {this.state.selectedType === CONSTANTS.SUBSTRING && <tr>
                                <td><Button
                                  type="primary-blue"
                                  shape="rounded"
                                  text={t(CONSTANTS.LABEL_ADD)}
                                  onClick={this.addRow} /></td>
                              </tr>}
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="clearfix" />
              </div>
            </div>
        }
      </Translation>
    );
  }
}

export default withRouter(Form);
